module.exports = __webpack_public_path__ + "static/media/close.13f544e8.svg";